import React, { useEffect, useState } from 'react';
import uploadViaPresign from '../script/uploadViaPresignV2';
import '../style/AddThumbnail.css';

const AddThumbnail = ({ setThumbnailImg, thumbnailImg }) => {
  const [profilePicFile, setProfilePicFile] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [uploading, setUploading] = useState(false);

  const uploadFile = async () => {
    if (!profilePicFile) { alert('Please select a file first.'); return; }
    setUploading(true);
    try {
      const imgUrl = await uploadViaPresign(profilePicFile, 'restaurant');
      setImageUrl(imgUrl);
      setThumbnailImg(imgUrl);
      setProfilePicFile(null);
    } catch (error) {
      console.error(error);
      alert('Error uploading file: ' + error.message);
    } finally {
      setUploading(false);
    }
  };

  const handleFileChange = (e) => {
    setProfilePicFile(e.target.files[0] || null);
  };

  useEffect(() => {
    setImageUrl(thumbnailImg);
  }, []);

  return (
    <div className="add-thumb-wrap">

      {/* ── Pick + upload row ── */}
      <div className="add-thumb-row">
        <label className="add-thumb-label" htmlFor="add-thumb-input">
          🖼 Choose Image
        </label>
        <input
          id="add-thumb-input"
          className="add-thumb-input"
          type="file"
          accept="image/jpeg,image/png,image/webp,image/heic"
          onChange={handleFileChange}
        />

        {profilePicFile && (
          <span className="add-thumb-filename">{profilePicFile.name}</span>
        )}

        <button
          className="add-thumb-btn"
          onClick={uploadFile}
          disabled={uploading || !profilePicFile}
        >
          {uploading ? '⏳ Uploading…' : '⬆ Upload'}
        </button>
      </div>

      {/* ── Thumbnail preview ── */}
      {imageUrl && (
        <div className="add-thumb-preview">
          <img src={imageUrl} alt="Thumbnail" />
          <div className="add-thumb-overlay">Click to replace</div>
        </div>
      )}

    </div>
  );
};

export default AddThumbnail;